import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { episodeNote, installments } from '@/mocks/episodes';

export default function EpisodesSection() {
  const [openId, setOpenId] = useState(installments[0].id);

  return (
    <section id="episodes" className="scroll-mt-24 bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-4xl">
        <SectionHeading
          eyebrow="Episodes"
          title="分集剧情完整版梳理"
          desc={episodeNote}
        />

        <div className="mt-10 space-y-4">
          {installments.map((item) => {
            const isOpen = item.id === openId;
            return (
              <article key={item.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? '' : item.id)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center gap-4 px-4 py-4 text-left md:px-6 md:py-5"
                  >
                    <span
                      className={`flex h-11 w-11 flex-none flex-col items-center justify-center rounded-md font-label text-xs leading-tight ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      <span className="font-heading text-base font-bold">{item.tab}</span>
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block font-heading text-base font-semibold text-foreground-950 md:text-lg">
                        {item.title}
                      </span>
                      <span className="mt-1 block font-label text-xs tracking-wide text-foreground-500">
                        {item.year} · {item.subtitle}
                      </span>
                    </span>
                    <i
                      className={`flex-none text-xl text-foreground-500 transition-transform ${
                        isOpen ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </button>
                </h3>

                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                  <div className="overflow-hidden">
                    <div className="border-t border-background-200 px-4 py-5 md:px-6">
                      <p className="text-sm leading-loose text-foreground-700">{item.synopsis}</p>

                      <h4 className="mt-5 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        关键情节
                      </h4>
                      <ul className="mt-3 space-y-2">
                        {item.beats.map((beat) => (
                          <li key={beat} className="flex items-start gap-2 text-xs leading-relaxed text-foreground-700 md:text-sm">
                            <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[7px] text-accent-500"></i>
                            {beat}
                          </li>
                        ))}
                      </ul>

                      <div className="mt-5 rounded-md border border-accent-200 bg-accent-50 p-4">
                        <p className="flex items-center gap-2 font-label text-xs uppercase tracking-wider text-accent-800">
                          <i className="ri-movie-2-line"></i>
                          名场面 · {item.keySceneTitle}
                        </p>
                        <p className="mt-2 text-xs leading-relaxed text-accent-950 md:text-sm">{item.keyScene}</p>
                      </div>

                      <p className="mt-4 flex items-start gap-2 rounded-md bg-secondary-100 p-3 text-xs leading-relaxed text-secondary-900 md:text-sm">
                        <i className="ri-flag-2-line mt-0.5 text-base text-secondary-700"></i>
                        <span>
                          <strong className="font-semibold">结局伏笔：</strong>
                          {item.endingHook}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}